// demo-webscm 2026 11 02 / ODOO-350612 (заказ владельца: «навигатор по интерфейсу… рубрики с иерархией… в стиле свободного виджета… правый фрейм»):
// чистые помощники правого дока навигатора (components/NavigatorDock.vue). Содержание — путь Бизнес-кейсов uc-path-ui-navigator
// (doc.tour.navigator = true): этап пути (AttrTab) = рубрика, строка шага = тема, tour.actions строки = шаги темы (highlight / wait_for / …).
// Здесь: дерево рубрик из шагов play_plan, личный прогресс (localStorage; серверные отметки — позже, по согласованию с Игорем), контекст экрана
// для вопроса помощнику, подбор объяснений uiHelp по словам вопроса, состояние дока по умолчанию. Без DOM и без сети — tests/unit/navigator.test.mjs.
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const isObj = (x) => !!(x && typeof x === 'object')

export const NAVIGATOR_PATH = 'uc-path-ui-navigator'
export const NAVIGATOR_WIDTH_DEFAULT = 400
export const NAVIGATOR_WIDTH_MIN = 300
export const NAVIGATOR_WIDTH_MAX = 720
export const NAVIGATOR_MODES = ['dock', 'free', 'strip']
export const NAVIGATOR_STRIP_WIDTH = 40   // demo-webscm 2026 11 02 / ODOO-350612 (замечание владельца: «при сворачивании… элементы виджетов ложатся под него»): смужка тоже занимает место справа
export const FLAG_NAVIGATOR = 'fe.guide.navigator'   // выключатель (по умолчанию вкл.): false — кнопки «Навігатор» нет, док не открывается

export function navigator_defaultState() {
    return { open: false, mode: 'dock', width: NAVIGATOR_WIDTH_DEFAULT, rect: null, tab: 'tree', path: NAVIGATOR_PATH, loading: false,
        steps: [], title: '', error: '', unavailable: false, current: 0, asked: 0, help: [], ask: '', ready: false }
}

// demo-webscm 2026 11 02 / ODOO-350612 (devap -134: ширина дока 500, выставленная перетаскиванием, после перезагрузки снова 400): сохранённое состояние
// (localStorage webscm_navigator) читалось только автооткрытием (настройка «Відкривати навігатор при старті»); при ручном открытии первый navigator_set
// брал умолчание 400 и тут же ПЕРЕЗАПИСЫВАЛ им сохранённую ширину. Теперь первый navigator_set сеанса сначала поднимает сохранённое (без open)
export const NAVIGATOR_LS_KEY = 'webscm_navigator'
export function navigator_withSaved(nav, v) {   // сохранённое состояние поверх текущего: режим, ширина, окно, вкладка (open — нет); _restored — уже поднято
    const out = { ...(isObj(nav) ? nav : navigator_defaultState()), _restored: true }
    if (!isObj(v)) return out
    // devap -136: вкладка «Крок» не поднимается — открытая тема (current) не сохраняется, после перезагрузки «Крок» показал бы другую тему, а списка тем не было
    // бы вовсе; «Помічник» — поднимается
    return { ...out, mode: NAVIGATOR_MODES.includes(v.mode) ? v.mode : 'dock', width: navigator_width(v.width), rect: v.rect || null, tab: v.tab === 'ask' ? 'ask' : 'tree' }
}
export function navigator_loadSaved(ls = globalThis.localStorage) {
    try { const v = JSON.parse(ls.getItem(NAVIGATOR_LS_KEY) || 'null'); return isObj(v) ? v : null } catch (e) { return null }
}
// следующее состояние дока для navigator_set: при первом вызове сеанса — поверх сохранённого; ширина — в пределах; сохраняет в ls
export function navigator_next(nav, patch, ls = globalThis.localStorage) {
    const base = (isObj(nav) && nav._restored) ? nav : navigator_withSaved(nav, navigator_loadSaved(ls))
    const out = { ...base, ...(isObj(patch) ? patch : {}) }
    if (isObj(patch) && 'width' in patch) out.width = navigator_width(patch.width)
    try { ls.setItem(NAVIGATOR_LS_KEY, JSON.stringify({ open: out.open, mode: out.mode, width: out.width, rect: out.rect, tab: out.tab })) } catch (e) { /* приватный режим */ }
    return out
}

// demo-webscm 2026 11 02 / ODOO-350612 (DM prod, тема 1 шаг 2: «Показую…» до 180 с, пока шаг wait_for ждёт действия пользователя, — читается как зависание):
// подпись главной кнопки дока. Показ идёт (busy) и ждёт действия пользователя (есть незавершённая проверка «Спробуйте самі») — «Waiting for your action»;
// идёт сам показ — «Showing…»; показа нет — «Show me». Ключи — английский текст (i18n/messages/*.json)
export function navigator_playLabel(busy, waiting) {
    if (!busy) return 'Show me'
    return waiting ? 'Waiting for your action' : 'Showing…'
}

// demo-webscm 2026 11 02 / ODOO-350612 (devap -107: пока проверка темы ждёт действия, «Покажи» в остальных темах неактивна до «Пропустити перевірку»):
// показ навигатора, который идёт для ДРУГОЙ темы (не n), — его надо снять при выборе темы n / «Покажи» в ней. Показ кейса (не путь навигатора) — не трогаем
export function navigator_runOther(session, n) {
    if (!isObj(session) || !session.busy) return false
    const p = isObj(session.path) ? session.path : null
    return !!p && p.id === NAVIGATOR_PATH && Number(p.step) !== Number(n)
}
// показ занят ИМЕННО этой темой (или чужим показом кейса) — «Покажи» неактивна; показ другой темы навигатора — кнопка доступна (снимет его)
export function navigator_busyHere(session, n) {
    return !!(isObj(session) && session.busy) && !navigator_runOther(session, n)
}

export function navigator_on(store) {
    try { return store?.setting?.(FLAG_NAVIGATOR, true) !== false } catch (e) { return true }
}

// ----------------------------------------------------------------- дерево рубрик
// шаги пути play_plan {n, id, kind, title, stage, minutes, note, tour} → [{stage, items:[step], done, total}] — рубрика = этап пути (подряд идущие шаги одного этапа)
export function navigator_tree(steps, done = {}) {
    const out = []
    for (const s of Array.isArray(steps) ? steps : []) {
        if (!isObj(s)) continue
        const stage = str(s.stage)
        let g = out[out.length - 1]
        if (!g || g.stage !== stage) { g = { stage, items: [], done: 0, total: 0 }; out.push(g) }
        g.items.push(s)
        g.total++
        if (done[str(s.n)]) g.done++
    }
    return out
}

// первый непройденный шаг (номер) — для «Продовжити»; нет — 0
export function navigator_nextStep(steps, done = {}) {
    for (const s of Array.isArray(steps) ? steps : []) if (isObj(s) && !done[str(s.n)]) return Number(s.n) || 0
    return 0
}

export function navigator_progress(steps, done = {}) {
    const total = Array.isArray(steps) ? steps.length : 0
    const d = Array.isArray(steps) ? steps.filter(s => isObj(s) && done[str(s.n)]).length : 0
    return { done: d, total, pct: total ? Math.round(d * 100 / total) : 0 }
}

// ----------------------------------------------------------------- личный прогресс (localStorage; ключ — пользователь + база + путь)
export function navigator_progressKey(store, path = NAVIGATOR_PATH) {
    const u = str(store?.user?.id || store?.user?.user || '')
    const db = str(store?.user?.database?.dbid || '')
    return `navigator:${u}:${db}:${path}`
}
export function navigator_progressLoad(key, ls = globalThis.localStorage) {
    try { const v = JSON.parse(ls?.getItem?.(key) || 'null'); return isObj(v) && isObj(v.done) ? v : { done: {}, at: '' } } catch (e) { return { done: {}, at: '' } }
}
export function navigator_progressSave(key, data, ls = globalThis.localStorage) {
    try { ls?.setItem?.(key, JSON.stringify({ done: data.done || {}, at: new Date().toISOString() })); return true } catch (e) { return false }
}
// demo-webscm 2026 11 02 / ODOO-350612 (fix 3: отметки терялись с новым профилем браузера): отметки живут на пользователе — USER.doc.params.navigatorDone
// (бэк get_user_settings / user_settings_save, список номеров тем), localStorage — только кэш. Бэк без поля отдаёт null → работаем по кэшу, молча.
// серверный список (или null — бэк не знает поля) + кэш браузера → карта done. Сервер знает поле — он источник истины (кэш другого браузера/профиля
// не воскрешает снятые отметки); не знает — кэш
export function navigator_doneMerge(serverList, localDone) {
    if (Array.isArray(serverList)) {
        const done = {}
        for (const n of serverList) { const k = str(n).trim(); if (/^\d+$/.test(k) && Number(k) > 0) done[k] = true }
        return done
    }
    const done = {}
    for (const k of Object.keys(isObj(localDone) ? localDone : {})) if (localDone[k]) done[str(k)] = true
    return done
}
// demo-webscm 2026 11 02 / ODOO-350612 (live48: вход на app.webscm.ai идёт через ядро без кода настроек — в ответе login / check_sessionKey нового
// профиля ключей навигатора нет): после входа в базу фронт сам спрашивает их у БЭКА СТЕНДА командой чтения user_settings_get (status ok +
// сохранённые ключи записи USER; ревью PR #226: прежний user_settings_save {} ПИСАЛ запись USER при каждом входе). Ответ → { atStart?, done? }
// только из РЕАЛЬНО пришедших полей; нет полей (старый бэк без команды отдаёт пустой ответ HTTP 200) / status не ok / не объект → null
// (стенд без поддержки — молчим, остаёмся на кэше браузера)
export function navigator_settingsFromAnswer(answer) {
    if (!isObj(answer) || (answer.status && answer.status !== 'ok')) return null
    const out = {}
    if (typeof answer.navigatorAtStart === 'boolean') out.atStart = answer.navigatorAtStart
    if (Array.isArray(answer.navigatorDone)) out.done = navigator_doneList(navigator_doneMerge(answer.navigatorDone, null))
    return Object.keys(out).length ? out : null
}
// карта done → список номеров для бэка (целые, по возрастанию, без повторов)
export function navigator_doneList(done) {
    const out = new Set()
    for (const k of Object.keys(isObj(done) ? done : {})) { const n = Number(k); if (done[k] && Number.isInteger(n) && n > 0) out.add(n) }
    return [...out].sort((a, b) => a - b)
}

// ----------------------------------------------------------------- помічник: исход опроса ответа бота
// demo-webscm 2026 11 02 / ODOO-350612 (fix 1): ответ get_msg / chat_llm_watch → { done, text, error }: done — статус конечный (не todo / work);
// text — message_md; конечный статус без текста — error 'empty'. Нет записи в ответе — не done (опрос продолжается)
export const ASK_STATUS_OPEN = ['', 'STATUS-todo', 'STATUS-work']
// demo-webscm 2026 11 02 / ODOO-350612 (live47: первая строка ответа в доке — «💭 думаю…»): маркеры потока «_💭 thinking…_» (любой язык — бэк
// localize-ит текст маркера: widgets.chat_localize_md) и «_🔧 `tool`_» (llm_client.llm_call_streaming) остаются в записанном message_md; чат
// показывает их строкой хода, док — только итоговый ответ, строки маркеров убираются
const ASK_MARKER_LINE = /^[ \t]*_(?:💭|🔧)[^\n]*_[ \t]*$\n?/gmu
export function navigator_askStrip(text) {
    return str(text).replace(ASK_MARKER_LINE, '').trim()
}
export function navigator_askOutcome(answer) {
    const m = isObj(answer) && isObj(answer.updateChatMsg) ? answer.updateChatMsg : null
    const st = str(m?.doc?.status)
    if (!m || ASK_STATUS_OPEN.includes(st)) return { done: false, text: '', error: '' }
    const text = navigator_askStrip(m.doc?.message_md)
    return { done: true, text, error: text ? '' : (st === 'STATUS-error' || st === 'STATUS-interrupted' ? st : 'empty') }
}

// ----------------------------------------------------------------- контекст экрана для помощника
export function navigator_context(store) {
    const ws = str(store?.activeWORKSPACE?.workspace)
    const page = str(store?.activeWORKSPACE?.active_page)
    const WS = store?.WORKSPACES?.[ws]
    const wsTitle = str(WS?.title || WS?.record?.title || ws)
    let pageTitle = ''
    try {
        const pages = WS?.record?.doc?.pages
        const p = Array.isArray(pages) ? pages.find(x => str(x?.node?.value) === page) : null
        pageTitle = str(p?.node?.valueStr || p?.title || '')
    } catch (e) { pageTitle = '' }
    const widgets = Array.isArray(WS?.ALL_WIDGETS) ? WS.ALL_WIDGETS.filter(w => w && str(w.page) === page) : []
    const act = widgets.find(w => w.isActive || w.active) || widgets[0] || null
    const pm = store?.process_model_record
    return {
        workspace: ws, workspace_title: wsTitle, page, page_title: pageTitle || page,
        widget: str(act?.widget || ''), widget_title: str(act?.title || act?.record?.title || ''),
        widgets: widgets.map(w => str(w.title || w.record?.title || w.widget)).filter(Boolean).slice(0, 8),
        process_model: str(pm?.title || pm?.id || ''), step: Number(store?.navigator?.current) || 0, step_title: str(store?.navigator?.steps?.find?.(s => s.n === store?.navigator?.current)?.title || ''),
    }
}

// текст сообщения помощнику: вопрос + блок контекста (бэк кладёт его в промпт как есть; source = ui-navigator добавляет правила навигатора)
export function navigator_askText(question, ctx, t = (x) => x) {
    const lines = [str(question).trim(), '', `---`, `_${t('Screen context (added by the navigator)')}:_`]
    if (ctx.workspace_title) lines.push(`- ${t('Workspace')}: ${ctx.workspace_title}${ctx.workspace ? ` (${ctx.workspace})` : ''}`)
    if (ctx.page_title) lines.push(`- ${t('Page')}: ${ctx.page_title}${ctx.page ? ` (${ctx.page})` : ''}`)
    if (ctx.widget_title || ctx.widget) lines.push(`- ${t('Widget')}: ${ctx.widget_title || ctx.widget}${ctx.widget ? ` (${ctx.widget})` : ''}`)
    if (ctx.widgets && ctx.widgets.length > 1) lines.push(`- ${t('Widgets on the page')}: ${ctx.widgets.join(' · ')}`)
    if (ctx.process_model) lines.push(`- ${t('Process model')}: ${ctx.process_model}`)
    if (ctx.step) lines.push(`- ${t('Navigator step')}: ${ctx.step}${ctx.step_title ? ` «${ctx.step_title}»` : ''}`)
    return lines.join('\n')
}

// подбор объяснений uiHelp по словам вопроса: entries — [{key, title, what, why, click, hotkey}] (uiHelp_rows / реестр), score — совпавшие слова ≥ 3 букв
export function navigator_helpSearch(question, entries, limit = 5) {
    const words = str(question).toLowerCase().split(/[^\p{L}\p{N}+]+/u).filter(w => w.length >= 3)
    if (!words.length) return []
    const scored = []
    for (const e of Array.isArray(entries) ? entries : []) {
        if (!isObj(e)) continue
        const hay = [e.title, e.what, e.why, e.click, e.hotkey, e.key].map(str).join(' ').toLowerCase()
        let score = 0
        for (const w of words) if (hay.includes(w)) score += (str(e.title).toLowerCase().includes(w) ? 3 : 1)
        if (score) scored.push({ ...e, score })
    }
    return scored.sort((a, b) => b.score - a.score || str(a.title).localeCompare(str(b.title))).slice(0, limit)
}

// demo-webscm 2026 11 02 / ODOO-350612 (замечание владельца: «экран не сразу перерисовывается… элементы виджетов ложатся под него. И при открытии тоже»):
// сколько места справа занимает навигатор у страницы — док: его ширина, смужка: NAVIGATOR_STRIP_WIDTH, свободное окно / закрыт / мобильный лист: 0.
// App.mainContainerStyle ставит это в margin-right и в том же такте (nextTick) пересчитывает раскладку страницы — без зазора и без перекрытия в обе стороны
export function navigator_reserve(nav, mobile = false) {
    if (!isObj(nav) || !nav.open || mobile) return 0
    if (nav.mode === 'strip') return NAVIGATOR_STRIP_WIDTH
    if (nav.mode === 'dock' || !nav.mode) return navigator_dockWidth(nav)
    return 0
}

// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «когда я сжимаю панель навигатора не возвращается назад пространство под виджеты… под док выделять
// часть рабочего пространства которое может сжиматься и растягиваться пользователем»): ширина дока — одна на док и на отступ страницы. Пока кромку тянут,
// живая ширина лежит в nav.dragWidth (не запоминается), отпустили — в nav.width (localStorage); раньше тянулся только DOM дока, а место страницы — после отпускания
export function navigator_dockWidth(nav) {
    if (!isObj(nav)) return NAVIGATOR_WIDTH_DEFAULT
    return navigator_width(nav.dragWidth != null && nav.dragWidth !== '' ? nav.dragWidth : nav.width)
}

// свободный (popout) виджет при смене свободной области по ширине: рект масштабируется относительно ЛЕВОГО края области, а не от края экрана —
// область {left, width} была old, стала next; края виджета отображаются отдельно (меньше накопления округлений при живом перетаскивании кромки)
export function navigator_areaRescaleX(rect, oldArea, nextArea) {
    const l = Number(rect?.left), w = Number(rect?.width)
    const ol = Number(oldArea?.left), ow = Number(oldArea?.width), nl = Number(nextArea?.left), nw = Number(nextArea?.width)
    if (![l, w, ol, ow, nl, nw].every(Number.isFinite) || ow <= 0 || nw <= 0) return null
    const k = nw / ow
    const left = Math.round(nl + (l - ol) * k), right = Math.round(nl + (l + w - ol) * k)
    return { left, width: Math.max(0, right - left) }
}

// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «в тексте (описании) можно было вставлять скриншоты… скрин или svg с диаграммой»): картинка шага —
// https://, путь сайта /… или data:image (png / jpeg / gif / webp / svg+xml, base64 — так importer вкладывает файл рядом с YAML; svg в <img> скриптов не исполняет,
// importer их к тому же вырезает). Ничего другого (javascript:, file:, http://) — не картинка
const IMAGE_RE = /^(https:\/\/[^\s"'<>]+|\/(?!\/)[^\s"'<>]*|data:image\/(png|jpeg|gif|webp|svg\+xml);base64,[A-Za-z0-9+/=]+)$/i
export function navigator_imageOk(src) {
    return IMAGE_RE.test(str(src).trim())
}

// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Приглушаем после прохождения шага или закрытия сообщения. Можно нажать на приглушённый и подсказка
// снова всплывает»): строка шага во вкладке «Крок» приглушена — пользователь закрыл её выноску (× / нажатие по цели: closed) или проверка шага пройдена (ok),
// пока выноску не показали снова (shown). Нажать можно, когда у строки есть подсказка для повторного показа (markId)
export function navigator_itemMuted(it) {
    if (!it || typeof it !== 'object') return false
    return !!it.closed || (it.kind === 'check' && !!it.ok && !it.shown)
}
export function navigator_itemReshowable(it) { return navigator_itemMuted(it) && !!it.markId }
// повторный показ строки: reshow(markId) — guideTarget_reshow; показана — строка не приглушена и ведёт новую подсказку; цели нет — false
export function navigator_itemReshow(it, reshow) {
    if (!navigator_itemReshowable(it) || typeof reshow !== 'function') return false
    const h = reshow(it.markId)
    if (!h) return false
    if (h.id) it.markId = h.id
    it.closed = false
    it.shown = true
    return true
}

// ширина дока в границах; на узких экранах (mobile UI) док — нижний лист, ширина не применяется
export function navigator_width(w) {
    const n = Number(w)
    if (!Number.isFinite(n)) return NAVIGATOR_WIDTH_DEFAULT
    return Math.min(NAVIGATOR_WIDTH_MAX, Math.max(NAVIGATOR_WIDTH_MIN, Math.round(n)))
}

// стартовый рект свободного окна: справа, на всю высоту под шапкой (как Free-виджет «Page widgets»: right-side)
export function navigator_freeRect(vw, vh, width = NAVIGATOR_WIDTH_DEFAULT, top = 52) {
    const w = Math.min(navigator_width(width), Math.max(NAVIGATOR_WIDTH_MIN, vw - 24))
    return { left: Math.max(12, vw - w - 12), top, width: w, height: Math.max(240, vh - top - 16) }
}
